// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Open Sans", sans-serif;
  height: 100vh;
  background: url('Login.jpg') 50% fixed;
  background-size: cover;
}

@keyframes spinner {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(359deg);
  }
}
* {
  box-sizing: border-box;
}

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
  background: rgba(4, 40, 68, 0.85);
}

.login {
  border-radius: 2px 2px 5px 5px;
  padding: 10px 20px 20px 20px;
  width: 90%;
  max-width: 320px;
  background: #ffffff;
  position: relative;
  padding-bottom: 80px;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.3);
}
.login.loading button {
  max-height: 100%;
  padding-top: 50px;
}
.login.loading button .spinner {
  opacity: 1;
  top: 40%;
}
.login.ok button {
  background-color: #8bc34a;
}
.login.ok button .spinner {
  border-radius: 0;
  border-top-color: transparent;
  border-right-color: transparent;
  height: 20px;
  animation: none;
  transform: rotateZ(-45deg);
}
.login input {
  display: block;
  padding: 15px 10px;
  margin-bottom: 10px;
  width: 100%;
  border: 1px solid #ddd;
  transition: border-width 0.2s ease;
  border-radius: 2px;
  color: #ccc;
}
.login input + i.fa {
  color: #fff;
  font-size: 1em;
  position: absolute;
  margin-top: -47px;
  opacity: 0;
  left: 0;
  transition: all 0.1s ease-in;
}
.login input:focus {
  outline: none;
  color: #444;
  border-color: #2196F3;
  border-left-width: 35px;
}
.login input:focus + i.fa {
  opacity: 1;
  left: 30px;
  transition: all 0.25s ease-out;
}
.login a {
  font-size: 0.8em;
  color: #2196F3;
  text-decoration: none;
}
.login .title {
  color: #444;
  font-size: 1.2em;
  font-weight: bold;
  margin: 10px 0 30px 0;
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}
.login button {
  width: 100%;
  height: 100%;
  padding: 10px 10px;
  background: #2196F3;
  color: #fff;
  display: block;
  border: none;
  margin-top: 20px;
  position: absolute;
  left: 0;
  bottom: 0;
  max-height: 60px;
  border: 0px solid rgba(0, 0, 0, 0.1);
  border-radius: 0 0 2px 2px;
  transform: rotateZ(0deg);
  transition: all 0.1s ease-out;
  border-bottom-width: 7px;
}
.login button .spinner {
  display: block;
  width: 40px;
  height: 40px;
  position: absolute;
  border: 4px solid #ffffff;
  border-top-color: rgba(255, 255, 255, 0.3);
  border-radius: 100%;
  left: 50%;
  top: 0;
  opacity: 0;
  margin-left: -20px;
  margin-top: -20px;
  animation: spinner 0.6s infinite linear;
  transition: top 0.3s 0.3s ease, opacity 0.3s 0.3s ease, border-radius 0.3s ease;
  box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.2);
}
.login:not(.loading) button:hover {
  box-shadow: 0px 1px 3px #2196F3;
}
.login:not(.loading) button:focus {
  border-bottom-width: 4px;
}

footer {
  display: block;
  padding-top: 50px;
  text-align: center;
  color: #ddd;
  font-weight: normal;
  text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.2);
  font-size: 0.8em;
}
footer a, footer a:link {
  color: #fff;
  text-decoration: none;
}

.titleLogin {
  color: white;
  font-weight: bold;
  font-size: 3em;
}`, "",{"version":3,"sources":["webpack://./src/app/auth/login/login.component.scss"],"names":[],"mappings":"AAEA;EACE,oCAAA;EACA,aAAA;EACA,sCAAA;EACA,sBAAA;AADF;;AAIA;EACE;IACE,wBAAA;EADF;EAIA;IACE,0BAAA;EAFF;AACF;AAKA;EACE,sBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,iCAAA;AAHF;;AAOA;EACE,8BAAA;EACA,4BAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,0CAAA;AAJF;AAOI;EACE,gBAAA;EACA,iBAAA;AALN;AAOM;EACE,UAAA;EACA,QAAA;AALR;AAWI;EACE,yBAAA;AATN;AAWM;EACE,gBAAA;EACA,6BAAA;EACA,+BAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;AATR;AAcE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;EACA,kBAAA;EACA,WAAA;AAZJ;AAcI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,OAAA;EACA,4BAAA;AAZN;AAeI;EAOE,aAAA;EACA,WAAA;EACA,qBArGI;EAsGJ,uBAAA;AAnBN;AAUM;EACE,UAAA;EACA,UAAA;EACA,8BAAA;AARR;AAkBE;EACE,gBAAA;EACA,cA5GM;EA6GN,qBAAA;AAhBJ;AAmBE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,6BAAA;EACA,oBAAA;AAjBJ;AAoBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBA7HM;EA8HN,WAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,gBAAA;EACA,oCAAA;EACA,0BAAA;EACA,wBAAA;EACA,6BAAA;EACA,wBAAA;AAlBJ;AAoBI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,uCAAA;EACA,+EAAA;EACA,0CAAA;AAlBN;AAsBE;EACE,+BAAA;AApBJ;AAuBE;EACE,wBAAA;AArBJ;;AAyBA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;AAtBF;AAwBE;EACE,WAAA;EACA,qBAAA;AAtBJ;;AA0BA;EACI,YAAA;EACA,iBAAA;EACA,cAAA;AAvBJ","sourcesContent":["$primary: #2196F3;\r\n\r\nbody {\r\n  font-family: \"Open Sans\", sans-serif;\r\n  height: 100vh;\r\n  background: url(\"../../../assets/images/backgrounds/Login.jpg\") 50% fixed;\r\n  background-size: cover;\r\n}\r\n\r\n@keyframes spinner {\r\n  0% {\r\n    transform: rotateZ(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotateZ(359deg);\r\n  }\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  width: 100%;\r\n  min-height: 100%;\r\n  padding: 20px;\r\n  background: rgba(darken($primary,40%), 0.85);\r\n}\r\n\r\n\r\n.login {\r\n  border-radius: 2px 2px 5px 5px;\r\n  padding: 10px 20px 20px 20px;\r\n  width: 90%;\r\n  max-width: 320px;\r\n  background: #ffffff;\r\n  position: relative;\r\n  padding-bottom: 80px;\r\n  box-shadow: 0px 1px 5px rgba(0,0,0,0.3);\r\n\r\n  &.loading {\r\n    button {\r\n      max-height: 100%;\r\n      padding-top: 50px;\r\n\r\n      .spinner {\r\n        opacity: 1;\r\n        top: 40%;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.ok {\r\n    button {\r\n      background-color: #8bc34a;\r\n\r\n      .spinner {\r\n        border-radius: 0;\r\n        border-top-color: transparent;\r\n        border-right-color: transparent;\r\n        height: 20px;\r\n        animation: none;\r\n        transform: rotateZ(-45deg);\r\n      }\r\n    }\r\n  }\r\n\r\n  input {\r\n    display: block;\r\n    padding: 15px 10px;\r\n    margin-bottom: 10px;\r\n    width: 100%;\r\n    border: 1px solid #ddd;\r\n    transition: border-width 0.2s ease;\r\n    border-radius: 2px;\r\n    color: #ccc;\r\n\r\n    & + i.fa {\r\n      color: #fff;\r\n      font-size: 1em;\r\n      position: absolute;\r\n      margin-top: -47px;\r\n      opacity: 0;\r\n      left: 0;\r\n      transition: all 0.1s ease-in;\r\n    }\r\n\r\n    &:focus {\r\n      & + i.fa {\r\n        opacity: 1;\r\n        left: 30px;\r\n        transition: all 0.25s ease-out;\r\n      }\r\n\r\n      outline: none;\r\n      color: #444;\r\n      border-color: $primary;\r\n      border-left-width: 35px;\r\n    }\r\n  }\r\n\r\n  a {\r\n    font-size: 0.8em;\r\n    color: $primary;\r\n    text-decoration: none;\r\n  }\r\n\r\n  .title {\r\n    color: #444;\r\n    font-size: 1.2em;\r\n    font-weight: bold;\r\n    margin: 10px 0 30px 0;\r\n    border-bottom: 1px solid #eee;\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  button {\r\n    width: 100%;\r\n    height: 100%;\r\n    padding: 10px 10px;\r\n    background: $primary;\r\n    color: #fff;\r\n    display: block;\r\n    border: none;\r\n    margin-top: 20px;\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: 0;\r\n    max-height: 60px;\r\n    border: 0px solid rgba(0,0,0,0.1);\r\n    border-radius: 0 0 2px 2px;\r\n    transform: rotateZ(0deg);\r\n    transition: all 0.1s ease-out;\r\n    border-bottom-width: 7px;\r\n\r\n    .spinner {\r\n      display: block;\r\n      width: 40px;\r\n      height: 40px;\r\n      position: absolute;\r\n      border: 4px solid #ffffff;\r\n      border-top-color: rgba(255,255,255,0.3);\r\n      border-radius: 100%;\r\n      left: 50%;\r\n      top: 0;\r\n      opacity: 0;\r\n      margin-left: -20px;\r\n      margin-top: -20px;\r\n      animation: spinner 0.6s infinite linear;\r\n      transition: top 0.3s 0.3s ease, opacity 0.3s 0.3s ease, border-radius 0.3s ease;\r\n      box-shadow: 0px 1px 0px rgba(0,0,0,0.2);\r\n    }\r\n  }\r\n\r\n  &:not(.loading) button:hover {\r\n    box-shadow: 0px 1px 3px $primary;\r\n  }\r\n\r\n  &:not(.loading) button:focus {\r\n    border-bottom-width: 4px;\r\n  }\r\n}\r\n\r\nfooter {\r\n  display: block;\r\n  padding-top: 50px;\r\n  text-align: center;\r\n  color: #ddd;\r\n  font-weight: normal;\r\n  text-shadow: 0px -1px 0px rgba(0,0,0,0.2);\r\n  font-size: 0.8em;\r\n\r\n  a, a:link {\r\n    color: #fff;\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n.titleLogin {\r\n    color: white;\r\n    font-weight: bold;\r\n    font-size: 3em;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
